import { M8StatementDTO } from 'services/production/types';
import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  idStatement: number;
};

export const getStatementById = async (
  params: Params
): Promise<M8StatementDTO> => {
  const response = await customFetch(
    getM8AdminURL(`getStatementById?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
